module.exports = __webpack_public_path__ + "assets/img/eternia-25.6ae3ee19.jpg";